.utm-data dt,
.utm-data dd {
    all: unset;
}

.utm-data-container,
.page-data-container {
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
}

.utm-data:not(:last-child) {
    border-bottom: 1px solid var(--off-white-dk);
}

.page-data-container > :not(:last-child) {
    border-bottom: 1px solid var(--off-white-dk);
}

.utm-data {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-data-header {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--off-white);
}
